import React, { useContext, useEffect, useState } from 'react';
import { View } from 'react-native';
import { Components, Theme } from '@oneamerica/dxp-ui-components';
import BreakpointConstants from '../../../../../constants/BreakpointConstants';
import responsiveStyle from './style';
import { formatCurrency } from '../../../../../utils';

const MakePaymentModal = ({
  isModalVisible,
  setModalVisible,
  payments = [],
  onCloseAnalytics,
  onSubmit = () => {},
}: {
  isModalVisible: boolean;
  setModalVisible: CallableFunction;
  payments: { title: string; amount: number }[];
  onCloseAnalytics?: CallableFunction;
  onSubmit: (selectedPayments: { title: string; amount: number }[]) => void;
}) => {
  const [checked, setChecked] = useState<
    { index: number; isChecked: boolean }[]
  >([]);
  const isBasePremium = payments?.some(
    (payment) => payment.title === 'Base Premium',
  );

  const style = responsiveStyle();
  const { width } = useContext(Theme.ResponsiveContext);
  let modalStyle, checkboxWrapperStyle, checkboxTextStyle, currencyWrapperStyle;
  if (BreakpointConstants.isLG(width)) {
    modalStyle = style.lgModalSize;
    checkboxWrapperStyle = style.lgCheckboxWrapper;
    checkboxTextStyle = style.lgCheckboxText;
    currencyWrapperStyle = style.lgCurrencyWrapper;
  } else if (BreakpointConstants.isMD(width)) {
    modalStyle = style.mdModalSize;
    checkboxWrapperStyle = style.mdCheckboxWrapper;
    checkboxTextStyle = style.mdCheckboxText;
    currencyWrapperStyle = style.mdCurrencyWrapper;
  } else {
    modalStyle = style.smModalSize;
    checkboxWrapperStyle = style.smCheckboxWrapper;
    checkboxTextStyle = style.smCheckboxText;
    currencyWrapperStyle = style.smCurrencyWrapper;
  }

  useEffect(() => {
    if (isModalVisible) {
      if (isBasePremium) {
        setChecked([{ index: 0, isChecked: true }]);
      } else {
        setChecked([]);
      }
    }
  }, [isModalVisible, isBasePremium]);

  const toggleSelected = (index: number, isChecked: boolean) => {
    setChecked((prev) => {
      const exists = prev.find((item) => item.index === index);
      if (isChecked) {
        if (!exists) {
          return [...prev, { index, isChecked }];
        }
      } else {
        return prev.filter((item) => item.index !== index);
      }
      return prev;
    });
  };

  const onClose = () => {
    onCloseAnalytics?.();
    setChecked([]);
    setModalVisible(false);
  };

  const handleSubmit = () => {
    const selectedPayments = checked.map((item) => payments[item.index]).filter(Boolean);
    onSubmit(selectedPayments);
    setModalVisible(false);
  };

  return (
    <Components.DialogModal
      style={modalStyle}
      width={'auto'}
      padding={20}
      Header={
        <Components.Text testID="modalTitle" style={style.modalTitle}>
          Please select which payment you'd like to make
          <Components.Text style={style.modalSubTitle}>
            (Select all that apply)
          </Components.Text>
        </Components.Text>
      }
      visible={isModalVisible}
      onClose={onClose}
      Footer={
        <View className="flex flex-row items-center justify-end flex-wrap">
          <Components.Button
            disabled={checked.length === 0}
            style={[
              !BreakpointConstants.isLG(width) &&
                style.customeServiceRequestBtn,
              style.serviceRequestBtn,
            ]}
            accessibilityRole="button"
            id="btnOutline"
            theme="primary"
            onPress={handleSubmit}
            testID={'makePaymentButton'}
          >
           Submit
          </Components.Button>
        </View>
      }
    >
      <View style={style.horizontalDivider} />

      <View style={style.placeholderWrapper}>
        {payments.map((item, index) => (
          <React.Fragment key={item.title}>
            <View className="my-3 flex flex-row items-center">
              <View style={checkboxWrapperStyle}>
                <Components.Checkbox
                  testID={item.title}
                  value={
                    isBasePremium && index === 0
                      ? true
                      : !!checked.find((c) => c.index === index)
                  }
                  disabled={isBasePremium && index === 0}
                  onChange={(isChecked) => {
                    toggleSelected(index, isChecked);
                  }}
                >
                  <Components.Text style={checkboxTextStyle}>
                    {item.title}
                  </Components.Text>
                </Components.Checkbox>
              </View>
              <Components.Text style={currencyWrapperStyle}>
                {formatCurrency(item.amount)}
              </Components.Text>
            </View>
            <View style={style.horizontalDivider} />
          </React.Fragment>
        ))}
      </View>
    </Components.DialogModal>
  );
};

export default MakePaymentModal;
